// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.industry-my-artifact input,
.industry-my-artifact textarea {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1px solid #ddd;
  border-radius: 6px; /* Ελαφρώς πιο στρογγυλεμένες γωνίες */
}

.industry-my-artifact textarea {
  height: 120px;
  resize: vertical;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/industry.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,kBAAkB,EAAE,sCAAsC;AAC5D;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB","sourcesContent":[".industry-my-artifact input,\r\n.industry-my-artifact textarea {\r\n  width: 100%;\r\n  padding: 12px;\r\n  margin: 10px 0;\r\n  border: 1px solid #ddd;\r\n  border-radius: 6px; /* Ελαφρώς πιο στρογγυλεμένες γωνίες */\r\n}\r\n\r\n.industry-my-artifact textarea {\r\n  height: 120px;\r\n  resize: vertical;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
